<template>
  <div class="NowShowingSlider">
    <div class="sdHome">
      <div v-if="routeName === '/'" class="col-12 sliderDetails px-0 pr-md-3 px-lg-3">
        <p class="movieCat">
          <!-- NOW SHOWING -->
           Confirmed Screenings <span class=" text-dark">(Join or choose your own)</span>
          <span class="txt-link">
            <!-- <router-link class="ml-3 ml-lg-4 mr-2" to>Watch the latest Movies in a theatre near you</router-link> -->
            <!-- <img
              id="tooltip-1"
              src="@/assets/img/svg/info-rd-icon.svg"
              class="rounded-circle"
            /> -->
            <button class="btn btn-danger viewmore-btn mr-4" @click="showModal = true">Know more</button>

            <b-modal v-model="showModal" ok-variant="danger">
              <ul>
                <li>
                  Choose your favourite movie.

                </li>
                <li>Choose the cinema and Screening type.
                </li>
                <li>
                  Choose the date and time.
                </li>
               </ul>

            </b-modal>
            <!-- ToolTip -->
            <b-tooltip target="tooltip-1" placement="right">

            </b-tooltip>
          </span>
        </p>
        <p class="link">
          <router-link :to="{ name: 'nowShowingList' }">(See All)</router-link>
        </p>
      </div>
    </div>

    <div class="sd">
      <div v-if="routeName !== '/'" class="col-12 sliderDetails px-0 px-md-3">
        <p class="movieCat">
          NOW SHOWING
          <span class="link ml-2">
            <router-link :to="{ name: 'nowShowingList' }">(See All)</router-link>
          </span>
        </p>
      </div>
    </div>
    <Slick ref="slick1" :options="movieSlider" class="now-showing">
      <div v-for="(singleMovie, singleindex) in NowShowing" :key="singleindex">
        <router-link :to="{
          name: 'createScreen',
          params: {
            movie_id: singleMovie.movie_id,
            content_lang_id: singleMovie.content_lang_id
          }
        }">
          <div class="movieSlider-container mx-auto text-center">
            <div class="img-container">
              <router-link :to="{
                name: 'createScreen',
                params: {
                  movie_id: singleMovie.movie_id,
                  content_lang_id: singleMovie.content_lang_id
                }
              }">
                <img alt v-lazy="singleMovie.md_thumbnail_url" class="img-fluid mx-auto banner" />
              </router-link>
            </div>
            <div class="text-center mx-auto pt-2 pt-md-3 movieSliderInfo">
              <p class="mb-0 title">{{ singleMovie.movie_title }}</p>
              <ul class="list-inline mb-0 mInfo">
                <li class="list-inline-item">{{ singleMovie.mf_name }}</li>
                <li class="list-inline-item">|</li>
                <li class="list-inline-item">{{ singleMovie.rating }}</li>
              </ul>
            </div>
          </div>
        </router-link>
      </div>
    </Slick>
  </div>
</template>

<script>
import Slick from "vue-slick";
import { makeRequest } from "@/helper/internet.js";
import $ from "jquery";
import MainServices from "@/services/mainService.js";
import { URL_BASE, LIMIT } from "@/helper/constants";

export default {
  name: "NowShowingSlider",

  components: {
    Slick
  },

  data() {
    return {
      routeName: "",
      showModal: false,
      movieSlider: {
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 5,
        slidesToScroll: 4,
        dots: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
              dots: false
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          }
        ]
      },
      NowShowing: []
    };
  },
  mounted() {
    this.routeName = window.location.pathname;
    if (screen.width > 768) {
      this.getNowShowingData();

    }
  },
  methods: {
    getNowShowingData: function () {
      let payload = { limit: LIMIT, currentPage: 1 };

      MainServices.GetTodaysScreening(payload)
        .then(response => {
          const { data } = response;
          console.log("response", response);
          if (data.status) {
            this.NowShowing = data.Records.data;
            this.$refs.slick1.destroy();
            this.$nextTick(() => {
              this.$refs.slick1.create();
              this.$refs.slick1.goTo(1, true);
            });
          }
        })
        .catch(error => {
          console.log("Error", error);
        });
    }
  }
};
</script>

<style>
.txt-link {}
</style>



// WEBPACK FOOTER //
// src/components/partials/nowShowingSlider.vue